export const listUrl = '/company/list'
export const createUrl = '/company/create'
export const updateUrl = '/company/update'
export const deleteUrl = '/company/delete'
export const exportUrl = '/company/export'
export const obdListUrl = '/company/{0}/obd/list'
export const obdUnauthorizedListUrl = '/company/{0}/obd/unauthorized/list'
export const addObdUrl = '/company/{0}/obd'
export const deleteObdUrl = '/company/{0}/obd'

export const resetPwdUrl = '/company/reset/{0}'

/**
 * 获取车辆列表
 */
export const vehicleListUrl = '/company/car/list'
export const addVehicleUrl = '/company/car'
export const updateVehicleUrl = '/company/car/{0}'
export const deleteVehicleUrl = '/company/car/{0}'
export const deleteVehicleListUrl = '/company/car/batch'
export const importVehicleUrl = process.env.VUE_APP_BASEURL + '/company/car/import'
export const exportVehicleUrl = '/company/car/export'

export const importObdUrl = process.env.VUE_APP_BASEURL + '/company/{0}/obdBindingImport'
export const exportObdUrl = '/company/obdBindingExport'

export const IOLIST = [
    [false, false, false, false], // 0
    [true, false, false, false], // 1
    [false, true, false, false], // 2
    [true, true, false, false], // 3
    [false, false, true, false],// 4
    [true, false, true, false], // 5
    [false, true, true, false], // 6
    [true, true, true, false], // 7
    [false, false, false, true], // 8 
    [true, false, false, true], // 9
    [false, true, false, true], // 10
    [true, true, false, true], // 11
    [true, false, true, true], // 13
    [false, true, true, true], // 14
    [false, false, true, true], //12
    [true, true, true, true] // 15
]

export const IO2LIST = [
    [false, false], // 0
    [true, false], // 1
    [false, true], // 2
    [true, true] // 3
]